const SvgComponent = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={13.662} height={13.659} {...props}>
        <path
            fill="#707070"
            d="M13.503 2.492a7.051 7.051 0 0 0-1.034-1.3A7.484 7.484 0 0 0 11.19.156 1.085 1.085 0 0 0 9.868.3L1.576 8.594a.517.517 0 0 0-.1.144L.04 12.824a.6.6 0 0 0 .144.648.622.622 0 0 0 .431.187.847.847 0 0 0 .2-.029l4.08-1.439a.328.328 0 0 0 .144-.1l8.3-8.289a1.051 1.051 0 0 0 .164-1.31ZM2.138 9.299a6.407 6.407 0 0 1 1.25.993 6.314 6.314 0 0 1 .977 1.252l-2.356.835a1.586 1.586 0 0 0-.287-.4 1.487 1.487 0 0 0-.4-.288Z"
        />
    </svg>
);
export default SvgComponent;
